export function scrollToSection(
  element: HTMLElement | null,
  options?: { offset?: number; smooth?: boolean }
) {
  if (!element) return;

  const header = document.querySelector(".header-bar") as HTMLElement | null;
  const headerHeight = header?.offsetHeight || 0;

  const elementTop = element.getBoundingClientRect().top + window.scrollY;

  window.scrollTo({
    top: elementTop - headerHeight - (options?.offset ?? 0),
    behavior: options?.smooth === false ? "auto" : "smooth",
  });
}
